export default function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Clamp index to be within the min/max index range. */
export function minMaxClamp(value: number, max: number): number {
  return Math.max(Math.min(value, max), 0);
}
